/**
 *
 */
import { useCallback, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import {
    CommonRestResponse,
    PropsWithPopup,
    useAppBridge,
    useMenuRouter,
    useWebviewBridge,
    useConfig,
    Modules,
} from 'scbk-services';
import { useLogout, useSession } from 'scbk-shared-module';
import { DialogWrapper } from 'scbk-ui-web';

import 'swiper/css';
import 'swiper/css/pagination';
import {
    useHolAstSetSetLogoutPopup,
    type HolAstSetSetLogoutPopupResponse,
} from '../../hooks/api/holAstSettingHooks';

const CloseAppPopup: React.FC<PropsWithPopup> = ({ isOpen, close, setOpen }) => {
    const { isLogin } = useSession();
    const { doLogout } = useLogout();
    const { doNAppExit } = useAppBridge();
    const { goMenu } = useMenuRouter();
    const { doNOpenBizWebView } = useWebviewBridge();
    const { t } = useTranslation();
    const { getConfig } = useConfig();

    const [logoutPopupData, setLogoutPopupData] = useState<
        HolAstSetSetLogoutPopupResponse | undefined
    >(undefined);
    const [isPopOpen, setIsPopOpen] = useState<boolean>(false);

    const { request: setLogoutPopup } = useHolAstSetSetLogoutPopup({
        skipLoading: true,
        onSuccess: async (response: CommonRestResponse<HolAstSetSetLogoutPopupResponse>) => {
            const res: HolAstSetSetLogoutPopupResponse | undefined = response.data?.data;
            setLogoutPopupData(res);
            setIsPopOpen(true);
        },
        onError: () => {
            setIsPopOpen(true);
        },
    });

    const mpmsDomain = getConfig(Modules.COMMON).mpmsDomain ?? 'https://m.sc.co.kr';

    useEffect(() => {
        if (isOpen) {
            setLogoutPopup({});
        }
    }, [isOpen]);

    const contentClick = useCallback(() => {
        if (logoutPopupData && Object.keys(logoutPopupData).length > 0) {
            if ('MA30' === logoutPopupData.targetVersion) {
                doNOpenBizWebView({
                    type: 'v3',
                    url: logoutPopupData.targetUrl,
                });
            } else if ('MA40' === logoutPopupData.targetVersion) {
                let parseRouteData = {};
                try {
                    parseRouteData = JSON.parse(logoutPopupData.targetParams || '');
                } catch {
                    /* empty */
                }

                const routeData = parseRouteData;
                goMenu(logoutPopupData.targetMenuId || '', { routeData: routeData });
            }
        }
    }, [logoutPopupData]);

    return (
        <DialogWrapper
            title=""
            open={isPopOpen}
            setOpen={setOpen}
            onClose={() => {
                setIsPopOpen(false);
                close?.();
            }}
            footer={[
                {
                    type: 'secondary',
                    title: t('closeAppPopup.001', { defaultValue: '취소' }),
                    handler: () => {
                        setIsPopOpen(false);
                    },
                    hasClose: true,
                },
                {
                    type: 'primary',
                    title: t('closeAppPopup.002', { defaultValue: '앱 종료' }),
                    handler: () => {
                        if (isLogin()) {
                            doLogout({
                                onLogout: () => {
                                    doNAppExit();
                                },
                            });
                            return;
                        }
                        doNAppExit();
                    },
                    hasClose: true,
                },
            ]}
        >
            {logoutPopupData?.fullImagePath && (
                <Link
                    to="javascript:void(0)"
                    className="flex justify-center"
                    onClick={contentClick}
                >
                    <img
                        src={mpmsDomain + logoutPopupData.fullImagePath}
                        alt={t('closeAppPopup.003', { defaultValue: '이벤트 자세히 보기' })}
                    />
                </Link>
            )}
        </DialogWrapper>
    );
};

export default CloseAppPopup;
